import { EditorState, Entity, AtomicBlockUtils, RichUtils, Modifier, ContentBlock, genKey } from 'draft-js';
import Immutable from 'immutable';
import { getSelectedBlock } from './getSelectedBlock';
import { updateEntity } from './updateEntity';
import { createRawFromText } from './createRawFromText';

export async function insertTable({ getEditorState, setEditorState, ref }) {
	/** @type {EditorState} */
	let editorState = getEditorState();
	let content = editorState.getCurrentContent();
	let selection = editorState.getSelection();
	let blockMap = content.getBlockMap();
	let blockKey = selection.getAnchorKey();

	let tableBlock = new ContentBlock({
		key: blockKey,
		type: 'table',
		text: '[表格]',
		data: createEmptyTable(),
	});

	if (ref) {
		ref.blockKey = blockKey;
	}

	blockMap = blockMap.set(blockKey, tableBlock);
	content = content.set('blockMap', blockMap);

	return setEditorState(EditorState.push(editorState, content, 'change-block-type'));
}

const createMany = (count, generate) => {
	const result = [];
	while (count--) result.push(generate());
	return result;
};

export const createTableAlign = (align = 'left') => ({
	key: genKey(),
	align,
});

export const createTableCell = (text = '') => ({
	key: genKey(),
	raw: createRawFromText(text),
});

export const createTableRow = (numberOfColumns) => ({
	key: genKey(),
	cells: createMany(numberOfColumns, createTableCell)
});

export function createEmptyTable(numberOfRows = 2, numberOfColumns = 2) {
	return Immutable.Map({
		aligns: createMany(numberOfColumns, () => createTableAlign('left')),
		rows: createMany(numberOfRows, () => createTableRow(numberOfColumns)),
	});
}

/**
 *
 * @param {EditorState} editorState
 */
export function getSelectedTableBlockKey(editorState) {
	const selectedBlock = getSelectedBlock(editorState);
	return selectedBlock && selectedBlock.getType() === 'table' ? selectedBlock.getKey() : null;
}

/**
 * 获取前面可删除的表格
 * @param {EditorState} editorState
 */
export function getDeletingTableBlock(editorState, backward) {
	const selectedBlock = getSelectedBlock(editorState);
	if (selectedBlock) {
		const selectedKey = selectedBlock.getKey();
		if (selectedBlock.getType() === 'table') {
			return selectedBlock;
		}
		const content = editorState.getCurrentContent();
		const selection = editorState.getSelection();

		if (backward) {
			const blockAfter = content.getBlockAfter(selectedKey);
			if (blockAfter && blockAfter.getType() === 'table' && selection.getEndOffset() === selectedBlock.getLength()) {
				return blockAfter;
			}
		}
		else {
			const blockBefore = content.getBlockBefore(selectedKey);
			if (blockBefore && blockBefore.getType() === 'table' && selection.getStartOffset() === 0) {
				return blockBefore;
			}
		}
	}
	return null;
}



// WEBPACK FOOTER //
// ./lib/helpers/tableUtils.js